import { Card, Col, Row } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import ApiHelper from "../../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../../Helpers/EnumHelper";
import { ParseDate } from "../../../../../Helpers/DateHelper";
import AppCardFooter from "./AppCardFooter";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const AppCardItem = ({ application, company, ticketId, setSelectedAssessment, isMobile }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 600);
    }
  }, [isCopied]);

  const handleCopyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => setIsCopied(true))
      .catch((err) => console.error("Failed to copy: ", err));
  };

  const isPastDeadline = (deadline) => {
    const deadlineDate = new Date(deadline);
    if (isNaN(deadlineDate.getTime())) throw new Error("Invalid date format");
    return deadlineDate < new Date();
  };

  const isUnavailable =
    (isPastDeadline(application.deadline) ||
      application.sessionsData?.clickCounter >= 5 ||
      (application.sessionsData?.remainingDuration <= 0 && application.applicationType === 0)) &&
    !application.sessionsData?.isFinished;

  const appIdString = `#${application.applicationType}A${application.id}T${ticketId}R${application?.sessionsData?.resultId || ""}`;

  return (
    <Card
      className={`default-card ${isUnavailable ? "unavailable" : ""} position-relative`}
      style={{ height: "350px" }}
    >
      <div
        className="position-absolute text-12 text-color-gray-light fw-medium"
        style={{ top: "0px", left: "10px", cursor: "pointer" }}
        onClick={() => handleCopyToClipboard(appIdString)}
        title={t("clickToCopyTooltip")}
      >
        {appIdString} {isCopied && <span className="animate__animated animate__fadeOutDown">{t("copiedLabel")}</span>}
      </div>

      <div className="d-flex flex-column h-100 p-3">
        {/* Logo */}
        <Row className="mx-0">
          <Image
            src={`${ApiHelper.cloudFrontURL}${folderEnum.logo}${company.companyLogoImageName}`}
            height="80"
            width="250"
          />
        </Row>

        {/* App type and date */}
        <Row className="fw-medium justify-content-between mt-3">
          <Col>
            <Row className="text-12 text-color-gray-light">
              <Col>{t("applicationType")}</Col>
            </Row>
            <Row className="text-16 text-color-primary fw-semibold">
              <Col>{application.name}</Col>
            </Row>
          </Col>
          <Col xs="auto">
            <Row className="text-12 text-color-gray-light justify-content-end">
              <Col xs="auto">{t("createdAtLabel")}</Col>
            </Row>
            <Row className="text-16 text-color-primary fw-semibold justify-content-end">
              <Col xs="auto">{ParseDate(application.createdAt).date}</Col>
            </Row>
          </Col>
        </Row>

        {/* Questions and deadline */}
        <Row className="fw-medium justify-content-between mt-auto">
          <Col xs="auto">
            <Row className="text-12 text-color-gray-light">
              <Col xs="auto">{t("questionCount")}</Col>
            </Row>
            <Row className="text-20 text-color-primary fw-semibold">
              <Col xs="auto">
                {application?.questionNumber || ""}
                {application?.questionNumber && application?.checkboxQuestionNumber ? " + " : ""}
                {application?.checkboxQuestionNumber || ""}
              </Col>
            </Row>
          </Col>
          <Col xs="auto">
            <Row className="text-12 text-color-gray-light justify-content-end">
              <Col xs="auto">{t("deadlineLabel")}</Col>
            </Row>
            <Row className="text-16 text-color-primary fw-semibold justify-content-end">
              <Col
                xs="auto"
                style={{
                  color:
                    isPastDeadline(application.deadline) &&
                    !application.sessionsData?.isFinished &&
                    !(application.sessionsData?.clickCounter >= 5) &&
                    "#f00",
                }}
              >
                {ParseDate(application.deadline).date}
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Footer */}
        <AppCardFooter
          application={application}
          ticketId={ticketId}
          setSelectedAssessment={setSelectedAssessment}
          company={company}
          isMobile={isMobile}
        />
      </div>
    </Card>
  );
};
export default AppCardItem;
